import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import cogoToast from 'cogo-toast';
import { addToWishlist, deleteFromWishlist, deleteAllFromWishlist } from '../store/slices/wishlist-slice';
import { addCartOrWishOne, deleteAllCartOrWishItem, deleteCartOrWishItem, getCartOrWishList } from '../utils/server';
import { useNavigate } from 'react-router-dom';

export const useWishlistPersist = () => {
  const dispatch = useDispatch();
  const wishlistItems = useSelector((state) => state.wishlist.wishlistItems);
  const navigate = useNavigate();

  // 检查用户是否登录
  const checkUserLogin = () => {
    const userInfo = JSON.parse(localStorage.getItem('user_info')) || {};
    if (!userInfo.id) {
      cogoToast.error('Please login first', { position: 'bottom-left' });
      navigate('/login');
      return false;
    }
    return true;
  };

  // 从服务器加载心愿单数据
  const loadWishlistFromServer = async () => {
    if (!checkUserLogin()) return;

    try {
      const { data } = await getCartOrWishList({
        flag: 0 // 0表示心愿单
      });

      if (data?.list && data.list.length > 0) {
        // 清空当前心愿单，然后重新添加从服务器获取的商品
        dispatch(deleteAllFromWishlist());

        // 逐个添加心愿单商品
        data.list.forEach(item => {
          dispatch(addToWishlist({
            ...item,
            id: item.productId,
            selectedProductColor: item.productColor,
            selectedProductSize: item.productSize,
            isTip: false // 不显示提示
          }));
        });
      }
    } catch (error) {
      cogoToast.error('Failed to load wishlist data', { position: 'bottom-left' });
    }
  };

  // 添加商品到心愿单并同步到服务器
  const addToWishlistWithPersist = async (product) => {
    if (!checkUserLogin()) return;

    // 检查是否已在心愿单中
    const isInWishlist = wishlistItems.findIndex(item => item.id === product.id) > -1;
    if (isInWishlist) {
      cogoToast.info('Product already in wishlist', { position: 'bottom-left' });
      return;
    }

    try {
      const result = await addCartOrWishOne({
        flag: 0, // 心愿单类型
        action: 1, // 增加
        productId: product.id,
        productName: product.productName,
        productPrice: product.price,
        skuId: product.skuId || '',
        isTip: product.isTip,
        // productColor: product.selectedProductColor || '',
        // productSize: product.selectedProductSize || '',
      });

      if (result && result.recordNo) {
        // 添加到Redux
        dispatch(addToWishlist({
          ...product,
          recordNo: result.recordNo
        }));
      } else {
        dispatch(addToWishlist(product));
      }
    } catch (error) {
      cogoToast.error('Failed to add to wishlist', { position: 'bottom-left' });
    }
  };

  // 从心愿单移除商品并同步到服务器
  const removeFromWishlist = async (productId, recordNo) => {
    if (!checkUserLogin()) return;

    try {
      if (recordNo) {
        await deleteCartOrWishItem({
          recordNo
        });
      }

      dispatch(deleteFromWishlist(productId));
    } catch (error) {
      cogoToast.error('Failed to remove from wishlist', { position: 'bottom-left' });
    }
  };

  // 清空心愿单
  const clearWishlist = async () => {
    if (!checkUserLogin()) return;

    try {
      await deleteAllCartOrWishItem({
        flag: 0 // 心愿单类型
      });

      dispatch(deleteAllFromWishlist());
      cogoToast.success('Wishlist cleared successfully', { position: 'bottom-left' });
    } catch (error) {
      cogoToast.error('Failed to clear wishlist', { position: 'bottom-left' });
    }
  };

  return {
    wishlistItems,
    addToWishlistWithPersist,
    removeFromWishlist,
    clearWishlist,
    loadWishlistFromServer
  };
};

export default useWishlistPersist; 
